import React, {Fragment} from 'react';
// import PropTypes from "prop-types";

import {connect} from 'react-redux';
// import ClientEdit from "./ClientEdit";
import {
  updateClient,
  loadClientDetailsRequest,
  loadClientDetailsSuccess,
  createCognitoAccountForClient
} from '../../redux/actions/clients';

import moment from 'moment';

import withStyles from '@material-ui/core/styles/withStyles';
import {withRouter} from 'react-router-dom';

// @material-ui/icons
import Face from '@material-ui/icons/Face';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// core components
import GridContainer from '../Grid/GridContainer.jsx';
import GridItem from '../Grid/GridItem.jsx';
import Card from '../Card/Card.jsx';
import CardBody from '../Card/CardBody.jsx';

import CardHeader from '../../components/Card/CardHeader';
import CustomInput from '../CustomInput/CustomInput';
import Button from '../CustomButtons/Button';
import NavPills from 'components/NavPills/NavPills.jsx';
import Clearfix from 'components/Clearfix/Clearfix.jsx';
import {API} from 'aws-amplify';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import {cardTitle} from '../../assets/jss/material-dashboard-pro-react';
import switchStyles from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx';
import selectStyles from 'assets/jss/material-dashboard-pro-react/customSelectStyle.jsx';

import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Check from '@material-ui/icons/Check';
import IdentificationListContainer from '../Identification/IdentificationList';
import HoldingAccountListContainer from '../HoldingAccounts/HoldingAccountList';
import ClientEditCommunication from './Edit/ClientEditCommunication';
import InputAdornment from '@material-ui/core/InputAdornment';

// For CustomReactSelect
import CustomReactSelect from 'components/Forms/CustomReactSelect/CustomReactSelect.jsx';

// For Radio buttons
import Radio from '@material-ui/core/Radio';
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';

import queryString from 'query-string';
import CustomTextField from '../CustomInput/CustomTextField';
import Icon from '@ant-design/icons/lib/components/Icon';

import {UserAccountComponent} from './BackOfficeClientEdit/UserAccount';
import {Personal} from './BackOfficeClientEdit/Personal';
import {Address} from './BackOfficeClientEdit/Address';

require('react-datetime');

const staffEditStyles = {
  ...switchStyles,
  ...selectStyles,
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    '& small': {
      fontSize: '80%',
      fontWeight: '400'
    }
  },
  cardCategory: {
    marginTop: '10px',
    color: '#999999 !important',
    textAlign: 'center'
  },
  description: {color: '#999999'},
  updateProfileButton: {float: 'right'},
  title: {
    color: '#3C4858',
    textDecoration: 'none'
  },

  formCategory: {
    marginBottom: '0',
    color: '#999999',
    fontSize: '14px',
    padding: '10px 0 10px'
  },
  registerButton: {float: 'right'},
  flexEnd: {
    display: 'flex',
    justifyContent: 'space-between'
  }
};

class BackOfficeClientEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // register form
      client_types_list: [],
      staff_list: [],
      team_list: [],
      aws_cognito_id: null,
      country_list: [],
      country_list_prio: [],
      language_id_list: [],
      marital_status_list: [],
      client_status_list: [],
      referral_source_list: [],
      client_beneficiary_list: [],
      loading: false,
      loaded: false,
      is_loading: true,
      account_type: '',
      title: '',
      first_name: '',
      middle_name: '',
      last_name: '',
      client_nickname: '', //#1068
      email: '',
      password: '',
      password_state: '',
      password_confirm: '',
      password_confirm_state: '',
      confirm_code: '',
      confirm_code_state: '',
      security_entities: [],
      security_entities_forexsport: false,
      security_entities_forexworldwide: false,
      security_entities_forexstudent: false,

      responsible_staff_member: '',
      responsible_staff_member_state: '',
      team_id: '',
      team_id_state: '',
      team_nickname: '',
      division_nickname: '',
      entity_nickname: '',

      nationality: '',
      language_id: '',
      date_of_birth: '',

      default_rate_total: '',

      account_status_notes: '',
      todo_list: [],
      client_communication: '',
      status_incomplete_details: false,
      referrer_code: '',
      forgetModal: false
    };
  }

  toggleForgetModal = bool => {
    this.setState({forgetModal: bool});
  };

  componentDidMount() {
    const query_strings = queryString.parse(this.props.location.search);
    if (query_strings) {
      switch (query_strings.tab) {
        case 'personal':
          this.setState({navpill_active: 1});
          break;
        default:
          this.setState({navpill_active: 0});
          break;
      }
    }

    if (this.props.client_detail_id) {
      this.props.loadClientDetailsRequest();
      API.get('clients', `/get/id/${this.props.client_detail_id}`)
        .then(client_detail => {
          console.log(client_detail);
          this.setState({
            loaded: true,
            aws_cognito_id: client_detail.aws_cognito_id,
            edit_mode: false,
            is_loading: false,
            email: client_detail.email,
            portal_account_created: client_detail.portal_account_created,
            portal_email_confirmed: client_detail.portal_email_confirmed,
            portal_mobile_confirmed: client_detail.portal_mobile_confirmed,
            portal_last_login_datetime: client_detail.portal_last_login_datetime,
            account_type: client_detail.account_type,
            account_status: client_detail.account_status,
            client_communication: client_detail.account_status,
            account_status_datetime: client_detail.account_status_datetime,
            account_status_staff: client_detail.account_status_staff,
            external_reference: client_detail.external_reference,
            title: client_detail.title,
            first_name: client_detail.first_name,
            middle_name: client_detail.middle_name,
            last_name: client_detail.last_name,
            client_nickname: client_detail.nickname, //#1068 nickname improvement by Tom
            residential_street_line_1: client_detail.residential_street_line_1,
            residential_street_line_2: client_detail.residential_street_line_2,
            residential_street_suburb: client_detail.residential_street_suburb,
            residential_street_state: client_detail.residential_street_state,
            residential_street_postcode: client_detail.residential_street_postcode,
            residential_street_country: client_detail.residential_street_country,
            postal_street_line_2: client_detail.postal_street_line_2,
            postal_street_line_1: client_detail.postal_street_line_1,
            postal_street_suburb: client_detail.postal_street_suburb,
            postal_street_state: client_detail.postal_street_state,
            postal_street_postcode: client_detail.postal_street_postcode,
            postal_street_country: client_detail.postal_street_country,
            telephone_home: client_detail.telephone_home,
            telephone_mobile: client_detail.telephone_mobile,
            telephone_work: client_detail.telephone_work,
            email_secondary: client_detail.email_secondary,

            responsible_staff_member: client_detail.responsible_staff_member,
            team_id: client_detail.team_id,
            nationality: client_detail.nationality,

            occupation: client_detail.occupation,
            employer: client_detail.employer,
            referral_source: client_detail.referral_source,
            referral_detail: client_detail.referral_detail,
            referrer_code: client_detail.referrer_code, //#1106 Add referrer_code field into edit client by Tom
            my_beneficiary: client_detail.my_beneficiary,

            selectedValue: 'customer_type_personal',
            selectedBusinessValue: 'customer_type_soleTrader',

            business_trading_name: client_detail.business_trading_name,
            business_abn: client_detail.business_abn,
            business_company_name: client_detail.business_company_name,
            business_company_number: client_detail.business_company_number,
            business_trust_name: client_detail.business_trust_name,

            // business_company_acn: client_detail.business_company_acn,
            // business_company_abn: client_detail.business_company_abn,

            language_id: client_detail.language_id,
            marital_status: client_detail.marital_status,
            date_of_birth: client_detail.date_of_birth,
            place_of_birth_city: client_detail.place_of_birth_city,
            place_of_birth_country: client_detail.place_of_birth_country,

            default_rate: client_detail.default_rate,
            default_rate_division: client_detail.default_rate_division,
            default_rate_team: client_detail.default_rate_team,
            default_rate_staff: client_detail.default_rate_staff,
            default_rate_client: client_detail.default_rate,
            default_rate_entity: client_detail.default_rate_entity,
            default_rate_total:
              Math.round(
                (Number(client_detail.default_rate_division) +
                  Number(client_detail.default_rate_entity) +
                  Number(client_detail.default_rate_staff) +
                  Number(client_detail.default_rate) +
                  Number(client_detail.default_rate_team)) *
                  100000
              ) / 100000,
            ec_info_dashboard_charts: client_detail.ec_info_dashboard_charts,
            ec_info_dashboard: client_detail.ec_info_dashboard,
            ec_info_economicnews: client_detail.ec_info_economicnews,
            ec_info_economicholidays: client_detail.ec_info_economicholidays,
            ec_info_charts: client_detail.ec_info_charts,
            ec_info_rates: client_detail.ec_info_rates,
            transfer_auto_accept: client_detail.transfer_auto_accept,
            transfer_forwards_allowed: client_detail.transfer_forwards_allowed,
            transfer_forwards_limit: client_detail.transfer_forwards_limit,
            transfer_max_deals_accepted: client_detail.transfer_max_deals_accepted,

            account_status_notes: client_detail.account_status_notes,
            status_incomplete_details: client_detail.status_incomplete_details,
            show_legacy_holding_acc: client_detail.show_legacy_holding_acc,
            feature_ledger: client_detail.feature_ledger,
            feature_multiClient: client_detail.feature_multiClient
          });

          if (client_detail.marketing_authorised == '1') {
            this.setState({marketing_authorised: true});
          } else {
            this.setState({marketing_authorised: false});
          }

          this.props.loadClientDetailsSuccess();
        })
        .catch(error => {
          console.log(error);
        });

      API.get('clients', '/client-types/get-list')
        .then(response => {
          this.setState({client_types_list: response});
        })
        .catch(error => {
          console.log(error);
        });
      API.get('clients', '/client-status/get')
        .then(response => {
          this.setState({client_status_list: response});
        })
        .catch(error => {
          console.log(error);
        });
      API.get('clients', '/client-referral-source/get')
        .then(response => {
          this.setState({referral_source_list: response});
        })
        .catch(error => {
          console.log(error);
        });
      API.get('staff', '/get-list-not-deleted')
        .then(response => {
          this.setState({staff_list: response});
        })
        .catch(error => {
          console.log(error);
        });
      API.get('teams', '/get-list-not-deleted')
        .then(response => {
          this.setState({team_list: response});
        })
        .catch(error => {
          console.log(error);
        });
      API.get('countries', '/list_not_deleted')
        .then(response => {
          this.setState({country_list_prio: response});
        })
        .catch(error => {
          console.log(error);
        });
      API.get('admin', '/languages/get')
        .then(response => {
          this.setState({language_id_list: response});
        })
        .catch(error => {
          console.log(error);
        });
      API.get('admin', '/marital-status/get')
        .then(response => {
          this.setState({marital_status_list: response});
        })
        .catch(error => {
          console.log(error);
        });

      API.get('clients', `/get/todo_list/${this.props.client_detail_id}`)
        .then(response => {
          this.setState({todo_list: response});
        })
        .catch(error => {
          console.log(error);
        });

      API.get('beneficiaries', `/get/by_client_id/${this.props.client_detail_id}`)
        .then(response => {
          //console.log(response)
          this.setState({client_beneficiary_list: response});
        })
        .catch(error => {
          console.log(error);
        });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.client_detail_id !== this.props.client_detail_id) {
      this.props.loadClientDetailsRequest();
      API.get('clients', `/get/id/${this.props.client_detail_id}`)
        .then(client_detail => {
          this.setState({
            loaded: true,
            is_loading: false,
            aws_cognito_id: client_detail.aws_cognito_id,
            email: client_detail.email,
            portal_account_created: client_detail.portal_account_created,
            portal_email_confirmed: client_detail.portal_email_confirmed,
            portal_mobile_confirmed: client_detail.portal_mobile_confirmed,
            portal_last_login_datetime: client_detail.portal_last_login_datetime,
            account_type: client_detail.account_type,
            account_status: client_detail.account_status,
            client_communication: client_detail.account_status,
            account_status_datetime: client_detail.account_status_datetime,
            account_status_staff: client_detail.account_status_staff,
            external_reference: client_detail.external_reference,
            title: client_detail.title,
            first_name: client_detail.first_name,
            middle_name: client_detail.middle_name,
            last_name: client_detail.last_name,
            residential_street_line_1: client_detail.residential_street_line_1,
            residential_street_line_2: client_detail.residential_street_line_2,
            residential_street_suburb: client_detail.residential_street_suburb,
            residential_street_state: client_detail.residential_street_state,
            residential_street_postcode: client_detail.residential_street_postcode,
            residential_street_country: client_detail.residential_street_country,
            postal_street_line_2: client_detail.postal_street_line_2,
            postal_street_line_1: client_detail.postal_street_line_1,
            postal_street_suburb: client_detail.postal_street_suburb,
            postal_street_state: client_detail.postal_street_state,
            postal_street_postcode: client_detail.postal_street_postcode,
            postal_street_country: client_detail.postal_street_country,

            telephone_home: client_detail.telephone_home,
            telephone_mobile: client_detail.telephone_mobile,
            telephone_work: client_detail.telephone_work,
            email_secondary: client_detail.email_secondary,

            responsible_staff_member: client_detail.responsible_staff_member,
            team_id: client_detail.team_id,
            nationality: client_detail.nationality,
            occupation: client_detail.occupation,
            employer: client_detail.employer,
            referral_source: client_detail.referral_source,
            referral_detail: client_detail.referral_detail,
            referrer_code: client_detail.referrer_code, //#1106 Add referrer_code field into edit client by Tom
            my_beneficiary: client_detail.my_beneficiary,
            marketing_authorised: client_detail.marketing_authorised,

            selectedValue: 'customer_type_personal',
            selectedBusinessValue: 'customer_type_soleTrader',

            business_trading_name: client_detail.business_trading_name, //#1117 data field fixed by Tom
            business_abn: client_detail.business_abn,
            business_company_name: client_detail.business_company_name,
            // business_company_acn: client_detail.business_company_acn,
            // business_company_abn: client_detail.business_company_abn,
            business_company_number: client_detail.business_company_number,
            business_trust_name: client_detail.business_trust_name,

            language_id: client_detail.language_id,
            marital_status: client_detail.marital_status,
            date_of_birth: client_detail.date_of_birth,
            place_of_birth_city: client_detail.place_of_birth_city,
            place_of_birth_country: client_detail.place_of_birth_country,

            default_rate: client_detail.default_rate,
            default_rate_division: client_detail.default_rate_division,
            default_rate_team: client_detail.default_rate_team,
            default_rate_staff: client_detail.default_rate_staff,
            default_rate_client: client_detail.default_rate,
            default_rate_entity: client_detail.default_rate_entity,
            default_rate_total:
              Math.round(
                (Number(client_detail.default_rate_division) +
                  Number(client_detail.default_rate_entity) +
                  Number(client_detail.default_rate_staff) +
                  Number(client_detail.default_rate) +
                  Number(client_detail.default_rate_team)) *
                  100000
              ) / 100000,
            transfer_auto_accept: client_detail.transfer_auto_accept,
            transfer_forwards_allowed: client_detail.transfer_forwards_allowed,
            transfer_forwards_limit: client_detail.transfer_forwards_limit,
            transfer_max_deals_accepted: client_detail.transfer_max_deals_accepted,
            show_legacy_holding_acc: client_detail.show_legacy_holding_acc,
            feature_ledger: client_detail.feature_ledger,
            feature_multiClient: client_detail.feature_multiClient
          });

          this.props.loadClientDetailsSuccess();
        })
        .catch(error => {
          console.log(error);
        });
    }
  }

  get_todo_list() {
    const arrayResult = [];

    for (let i = 0; i < this.state.todo_list.length; i++) {
      let Status = 'Completed';
      if (moment(this.state.todo_list[i].datetime_completed).format('DD/MM/YYYY') == 'Invalid date') {
        Status = "<Button color='warning' onClick={() => this.change_todo_status()} >Not Completed</Button>";
      }

      arrayResult.push([
        this.state.todo_list[i].client_id,
        this.state.todo_list[i].transfer_id,
        this.state.todo_list[i].description,
        moment(this.state.todo_list[i].datetime_created).format('DD/MM/YYYY'),
        moment(this.state.todo_list[i].datetime_completed).format('DD/MM/YYYY'),
        Status
      ]);
    }
    return arrayResult;
  }

  buildTableData() {
    const client_list_length = this.state.todo_list.length;
    if (client_list_length > 0) {
      return this.state.todo_list.map((prop, key) => {
        var Status = 'Completed';
        if (moment(prop.datetime_completed).format('DD/MM/YYYY') == 'Invalid date') {
          var Status = 'Not Completed';
          return {
            client_id: prop.client_id,
            transfer_id: prop.transfer_id,
            description: prop.description,
            datetime_created: moment(prop.datetime_created).format('DD/MM/YYYY'),
            datetime_completed: moment(prop.datetime_completed).format('DD/MM/YYYY'),
            actions: (
              <div className='actions-right'>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    API.put('clients', `/update/todo_id/${prop.id}`, {body: {datetime_completed: new Date()}})
                      .then(response => {
                        window.location.reload();
                      })
                      .catch(error => {
                        console.log(error);
                      });
                  }}
                >
                  Not Completed
                </Button>
              </div>
            )
          };
        }
        return {
          client_id: prop.client_id,
          transfer_id: prop.transfer_id,
          description: prop.description,
          datetime_created: moment(prop.datetime_created).format('DD/MM/YYYY'),
          datetime_completed: moment(prop.datetime_completed).format('DD/MM/YYYY'),
          actions: (
            <div className='actions-right'>
              <Button variant='contained' color='secondary'>
                Completed
              </Button>
            </div>
          )
        };
      });
    }
  }

  async saveClientDetail(client_detail) {
    this.props.updateClient(client_detail, this.props.client_detail_id);
  }

  verifyCognitoPassword(value) {
    // Old pattern
    //var passwordRex = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){8,16}$/;

    const passwordRex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*\S)[A-Za-z\d\S]{6,}$/;
    // This pattern requires at least 6 characters and contain at least 1 number and 1 character

    if (passwordRex.test(value)) {
      return true;
    }
    return false;
  }

  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }

  compare(string1, string2) {
    if (string1 === string2) {
      return true;
    }
    return false;
  }

  change(event, stateName, type, stateNameEqualTo) {
    switch (type) {
      case 'email':
        if (this.verifyEmail(event.target.value)) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + '_state']: 'error'});
        }
        break;
      case 'length':
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + '_state']: 'error'});
        }
        break;
      case 'password':
        if (this.verifyCognitoPassword(event.target.value)) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + '_state']: 'error'});
        }
        break;
      case 'equalTo':
        if (this.compare(event.target.value, this.state[stateNameEqualTo])) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + '_state']: 'error'});
        }
        break;
      default:
        break;
    }
    this.setState({[stateName]: event.target.value});
    // this.props.updateNewClientCreation(stateName, event.target.value)
  }

  migrationHandleChange = event => {
    this.setState({migrationBackendId: event.target.value});
  };
  migrationFxMember = async event => {
    console.log(`Migrating from FX - Member ${this.state.migrationBackendId}`);
    let migrationResponse;
    try {
      migrationResponse = await API.post('clients', '/migration', {
        body: {
          database: 'fx',
          clientId: this.props.client_detail_id,
          backendId: this.state.migrationBackendId
        }
      });
    } catch (error) {
      console.log(error);
    }
    console.log(migrationResponse);
  };

  migrationFwwMember = async event => {
    console.log(`Migrating from FWW - Member ${this.state.migrationBackendId}`);
    let migrationResponse;
    try {
      migrationResponse = await API.post('clients', '/migration', {
        body: {
          database: 'fww',
          clientId: this.props.client_detail_id,
          backendId: this.state.migrationBackendId
        }
      });
    } catch (error) {
      console.log(error);
    }
    console.log(migrationResponse);
  };

  migrationFxBeneficiaries = async event => {
    console.log(`Migrating from FX - Beneficiaries ${this.state.migrationBackendId}`);
    let migrationResponse;
    try {
      migrationResponse = await API.post('beneficiaries', '/migration', {
        body: {
          database: 'fx',
          clientId: this.props.client_detail_id,
          backendId: this.state.migrationBackendId
        }
      });
    } catch (error) {
      console.log(error);
    }
    console.log(migrationResponse);
  };

  migrationFwwBeneficiaries = async event => {
    console.log(`Migrating from FWW - Beneficiaries ${this.state.migrationBackendId}`);
    let migrationResponse;
    try {
      migrationResponse = await API.post('beneficiaries', '/migration', {
        body: {
          database: 'fww',
          clientId: this.props.client_detail_id,
          backendId: this.state.migrationBackendId
        }
      });
    } catch (error) {
      console.log(error);
    }
    console.log(migrationResponse);
  };

  migrationFxTransfers = async event => {
    console.log(`Migrating from FX - Transfers ${this.state.migrationBackendId}`);
    let migrationResponse;
    try {
      migrationResponse = await API.post('transfers', '/migration', {
        body: {
          database: 'fx',
          clientId: this.props.client_detail_id,
          backendId: this.state.migrationBackendId
        }
      });
    } catch (error) {
      console.log(error);
    }
    console.log(migrationResponse);
  };

  migrationFwwTransfers = async event => {
    console.log(`Migrating from FWW - Transfers ${this.state.migrationBackendId}`);
    let migrationResponse;
    try {
      migrationResponse = await API.post('transfers', '/migration', {
        body: {
          database: 'fww',
          clientId: this.props.client_detail_id,
          backendId: this.state.migrationBackendId
        }
      });
    } catch (error) {
      console.log(error);
    }
    console.log(migrationResponse);
  };

  handleChange = event => {
    if (event.target.id === 'business_company_number') {
      //validation for length of business_company_number
      if (event.target.value.length < 17) {
        this.setState({business_company_number_state: 'success'});
      } else {
        this.setState({business_company_number_state: 'error'});
      }
      //this.props.change(event, event.target.label, type, stateNameEqualTo);
      this.setState({[event.target.id]: event.target.value});
    } else {
      this.setState({[event.target.id]: event.target.value});
    }
  };

  /*
   *  Function build for #1068 handleNicknameChange() by Tom
   */
  handleNameChange = (event, toEdit_first_name, toEdit_last_name) => {
    if (event.target.id === 'first_name') {
      //set firstname and nickname
      this.setState({
        [event.target.id]: event.target.value,
        client_nickname: event.target.value + ', ' + toEdit_last_name
      });
    } else if (event.target.id === 'last_name') {
      this.setState({
        [event.target.id]: event.target.value,
        client_nickname: toEdit_first_name + ', ' + event.target.value
      });
    } else {
      this.setState({[event.target.id]: event.target.value});
    }
  };

  /*
   *  Function build for #1068 handleNicknameChange() by Tom
   */
  handleNicknameChange = event => {
    //console.log(event.target.value);

    // == Leave this logic for future use but turn off now #1068 == by Tom
    // let split_result = event.target.value.split(", ");

    // console.log([split_result[0]]);
    // console.log([split_result[1]]);

    //Nickname format: Yang, Tom (Lastname, First_name)
    this.setState({
      [event.target.id]: event.target.value
      //first_name: split_result[1],
      //last_name: split_result[0]
    });
  };

  // For CustomReactSelect
  handleCustomReactSelectChange = name => value => {
    if (value === null) {
      this.setState({[name]: null});
    } else {
      this.setState({[name]: value.value});
    }
  };

  handleToggle = name => event => {
    this.setState({[name]: event.target.checked});
  };

  toggleEdit = () => {
    const edit_mode = !this.state.edit_mode;
    this.setState({edit_mode: edit_mode});
  };

  handleSelectChange = event => {
    this.setState({[event.target.name]: event.target.value});
    if (event.target.name === 'team_id') {
      this.getTeamDetails(event.target.value);
    }
    if (event.target.name === 'account_status') {
      this.setState({
        account_status_datetime: new Date().toISOString().slice(0, 19).replace('T', ' '),
        account_status_staff: this.props.app_state.current_staff.id
      });
    }
  };

  getTeamDetails(team_id) {
    API.get('teams', `/get/div-entity/${team_id}`)
      .then(response => {
        // console.log(response);
        this.setState({
          division_nickname: response.division_nickname,
          entity_nickname: response.entity_nickname,
          team_nickname: response.team_nickname
        });
      })
      .catch(error => {
        console.log(error);
      });
  }

  validSecondaryEmail(secondaryEmail) {
    // check is Secondary email null
    if (this.state.email_secondary === null) {
      this.setState({email_secondary: ' '});
      return this.state.email_secondary;
    }
    return this.state.email_secondary.toLowerCase();
  }

  onHandleSubmit = async event => {
    event.preventDefault();
    this.setState({isLoading: true});

    const {
      // aws_cognito_id,
      title,
      first_name,
      middle_name,
      last_name,
      //client_nickname #1068
      client_nickname,

      // email
      account_type,
      account_status,
      account_status_datetime,
      account_status_staff,
      account_status_notes,
      external_reference,
      residential_street_line_1,
      residential_street_line_2,
      residential_street_suburb,
      residential_street_state,
      residential_street_postcode,
      residential_street_country,
      postal_street_line_1,
      postal_street_line_2,
      postal_street_suburb,
      postal_street_state,
      postal_street_postcode,
      postal_street_country,
      telephone_home,
      telephone_mobile,
      telephone_work,
      email_secondary,
      responsible_staff_member,
      team_id,
      nationality,
      occupation,
      employer,
      referral_source,
      referral_detail,
      referrer_code, //#1106 Add referrer_code field into edit client by Tom
      my_beneficiary,
      marketing_authorised,
      business_trading_name,
      business_abn,
      business_company_name,
      business_company_number,
      business_trust_name,
      // business_company_acn, //#1117 data field fix by Tom
      // business_company_abn,
      language_id,
      marital_status,
      date_of_birth,
      place_of_birth_city,
      place_of_birth_country,
      default_rate,
      ec_info_dashboard_charts,
      ec_info_dashboard,
      ec_info_economicnews,
      ec_info_economicholidays,
      ec_info_charts,
      ec_info_rates,
      transfer_auto_accept,
      transfer_forwards_allowed,
      transfer_forwards_limit,
      transfer_max_deals_accepted,
      default_rate_division,
      default_rate_team,
      default_rate_staff,
      default_rate_client,
      default_rate_entity,
      status_incomplete_details,
      show_legacy_holding_acc,
      feature_ledger,
      feature_multiClient
    } = this.state;
    try {
      await this.saveClientDetail({
        // aws_cognito_id: aws_cognito_id,
        account_type: account_type,
        account_status: account_status,
        account_status_datetime,
        account_status_staff,
        account_status_notes: account_status_notes,
        title: title,
        first_name: first_name,
        middle_name: middle_name,
        last_name: last_name,
        nickname: client_nickname,
        external_reference,
        residential_street_line_1: residential_street_line_1,
        residential_street_line_2: residential_street_line_2,
        residential_street_suburb: residential_street_suburb,
        residential_street_state: residential_street_state,
        residential_street_postcode: residential_street_postcode,
        residential_street_country: residential_street_country,
        postal_street_line_1: postal_street_line_1,
        postal_street_line_2: postal_street_line_2,
        postal_street_suburb: postal_street_suburb,
        postal_street_state: postal_street_state,
        postal_street_postcode: postal_street_postcode,
        postal_street_country: postal_street_country,
        telephone_home: telephone_home,
        telephone_mobile: telephone_mobile,
        telephone_work: telephone_work,
        email_secondary: this.validSecondaryEmail(email_secondary),
        responsible_staff_member: responsible_staff_member,
        team_id: team_id,
        nationality: nationality,
        occupation,
        employer,
        referral_source,
        referral_detail,
        referrer_code: referrer_code, //1106
        my_beneficiary,
        marketing_authorised,
        //#1117 data field fixed by Tom
        business_trading_name: business_trading_name,
        business_company_name: business_company_name,
        business_company_number: business_company_number,
        business_abn: business_abn,
        business_trust_name: business_trust_name,
        //end of #1117 fixed
        language_id,
        marital_status,
        date_of_birth,
        place_of_birth_city,
        place_of_birth_country,
        default_rate,
        ec_info_dashboard_charts,
        ec_info_dashboard,
        ec_info_economicnews,
        ec_info_economicholidays,
        ec_info_charts,
        ec_info_rates,
        transfer_auto_accept,
        transfer_forwards_allowed,
        transfer_forwards_limit,
        transfer_max_deals_accepted,
        default_rate_division: default_rate_division,
        default_rate_team: default_rate_team,
        default_rate_staff: default_rate_staff,
        default_rate: default_rate_client,
        default_rate_entity: default_rate_entity,
        status_incomplete_details: status_incomplete_details,
        show_legacy_holding_acc,
        feature_ledger,
        feature_multiClient
      });
    } catch (e) {
      // alert(e);
      // this.setState({ isLoading: false });
    }
    // this.props.reload_user(this.state.aws_cognito_id);
  };

  forgetPassword = async () => {
    if (this.state.password_confirm !== this.state.password) {
      this.setState({
        password_helptext: 'Password and Confirm Password must match',
        password_state: 'error'
      });
      return;
    }
    if (
      this.state.password_confirm === this.state.password &&
      this.state.password_confirm !== '' &&
      this.state.password !== '' &&
      this.state.password_state === 'success'
    ) {
      try {
        this.setState({loading: true});
        await API.post('clients', '/clients/change/password', {
          body: {
            clientId: this.props.client_detail_id,
            newPassword: this.state.password
          }
        });
        this.toggleForgetModal(false);
        this.setState({loading: false});
      } catch (e) {
        this.setState({loading: false});
        console.error('error occured', e);
      }
    }
  };

  handleCreateClientPortalAccount = () => {
    if (this.state.password_state === 'success' && this.state.password_confirm_state === 'success') {
      // console.log(this.props.client_detail_id);
      this.props.createCognitoAccountForClient(
        this.props.client_detail_id,
        this.state.email,
        this.state.password,
        this.state.language_id
      );
      this.setState({portal_account_created: 1});
    } else {
      if (this.state.password_state === '') {
        this.setState({password_state: 'error'});
      }
      if (this.state.password_confirm_state === '') {
        this.setState({password_confirm_state: 'error'});
      }
    }
  };

  getClientPortalCardContent() {
    const {classes} = this.props;
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    };
    const portal_last_login = this.state.portal_last_login_datetime
      ? new Date(this.state.portal_last_login_datetime).toLocaleString('en-AU', options)
      : 'N/A';

    if (!this.state.portal_account_created) {
      return (
        <React.Fragment>
          <p>
            {this.state.first_name} <strong>DOES NOT HAVE</strong> a client portal registration
          </p>
          <p>
            Clicking the button below will initiate the account creation procedure. This will send an email to{' '}
            {this.state.email} advising them of account opening and requesting email confirmation.
          </p>
          <p>
            {this.state.password_state === 'error' && (
              <strong style={{color: 'red'}}>
                <em>
                  Please note passwords must contain at least 1 uppercase and 1 lowercase character, as well as 1 number
                  and 1 special character
                </em>
              </strong>
            )}
          </p>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText='Username (primary email)'
                id='username_display_email'
                formControlProps={{fullWidth: true}}
                inputProps={{
                  disabled: true,
                  value: this.state.email || '',
                  onChange: event => {
                    this.handleChange(event);
                  }
                }}
              />
              <CustomInput
                success={this.state.password_state === 'success'}
                error={this.state.password_state === 'error'}
                labelText='Password *'
                id='password'
                formControlProps={{fullWidth: true}}
                inputProps={{
                  value: this.state.password,
                  onChange: event => this.change(event, 'password', 'password'),
                  type: 'password'
                }}
              />
              <CustomInput
                success={this.state.password_confirm_state === 'success'}
                error={this.state.password_confirm_state === 'error'}
                labelText='Confirm Password *'
                id='password_confirm'
                formControlProps={{fullWidth: true}}
                inputProps={{
                  value: this.state.password_confirm,
                  onChange: event => this.change(event, 'password_confirm', 'equalTo', 'password'),
                  type: 'password'
                }}
              />
            </GridItem>
          </GridContainer>
          <Button
            color='primary'
            onClick={() => this.handleCreateClientPortalAccount()}
            // type="submit"
            className={classes.updateProfileButton}
          >
            Create client portal account
          </Button>
        </React.Fragment>
      );
    }

    if (!this.state.portal_email_confirmed) {
      return (
        <React.Fragment>
          <p>
            {this.state.first_name}
            's portal account <strong>HAS NOT </strong> been confirmed.
          </p>
          <p>
            An email has been sent to {this.state.email} with a confirmation code. The user should visit
            https://portal.forexworldwide.com and verify their account.
          </p>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <ul>
          <li>{this.state.first_name} has a client portal registration</li>
          <li>
            {this.state.first_name}
            's client portal registration has been confirmed.
          </li>
          <li>
            {this.state.first_name} last CRM login: {portal_last_login}
          </li>
        </ul>
        {/* <Button>Login to Client Portal</Button> */}
        <Button onClick={() => this.toggleForgetModal(true)}>Change user password</Button>

        {/* <Dialog
          open={this.state.forgetModal}
          onClose={() => this.toggleForgetModal(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Forget Password</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <CustomTextField
                // success={this.state.password_state === 'success'}
                // error={this.state.password_state === 'error'}
                id="password"
                // helpText={this.state.password_helptext}
                formControlProps={{
                  fullWidth: true,
                  className: classes.customFormControlClasses
                }}
                inputProps={{
                  variant: 'outlined',
                  label: 'Password',
                  style: {backgroundColor: 'white'},
                  value: this.state.password,
                  onChange: event => this.validatePassword(event, 'password', 'password'),
                  type: 'password',
                  startAdornment: (
                    <InputAdornment position="start" className={classes.inputAdornment}>
                      <Icon className={classes.inputAdornmentIcon}>lock_outline</Icon>
                    </InputAdornment>
                  )
                }}
              />
              <CustomTextField
                // labelText="Confirm Password..."
                // success={this.state.confirm_password_state === 'success'}
                // error={this.state.confirm_password_state === 'error'}
                id="confirm_password"
                formControlProps={{
                  fullWidth: true,
                  className: classes.customFormControlClasses
                }}
                inputProps={{
                  value: this.state.password_confirm,
                  variant: 'outlined',
                  label: 'Confirm Password',
                  style: {
                    backgroundColor: 'white',
                    padding: '0px'
                  },
                  onChange: event => this.validatePassword(event, 'password_confirm', 'password_confirm'),
                  type: 'password',
                  startAdornment: (
                    <InputAdornment position="start" className={classes.inputAdornment}>
                      <Icon className={classes.inputAdornmentIcon}>lock_outline</Icon>
                    </InputAdornment>
                  )
                }}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.toggleForgetModal(false)} color="primary">
              Cancel
            </Button>
            <Button onClick={() => this.forgetPassword()} color="danger" autoFocus disabled={this.state.loading}>
              Change Password
            </Button>
          </DialogActions>
        </Dialog> */}
      </React.Fragment>
    );
  }

  getClientClassificationCardContent() {
    const {classes} = this.props;

    // For CustomReactSelect. Generate select options for dropdown list.
    const account_type_select_options = this.state.client_types_list.map(item => ({
      value: item.id,
      label: item.nickname
    }));
    const account_status_select_options = this.state.client_status_list.map(item => ({
      value: item.id,
      label: item.nickname
    }));
    const responsible_staff_member_select_options = this.state.staff_list
      .sort((a, b) => a.last_name.localeCompare(b.last_name))
      .map(item => ({
        value: item.id,
        label:
          item.last_name.toUpperCase() +
          ', ' +
          item.first_name +
          ' - from ' +
          item.division_nickname +
          ' (' +
          item.team_nickname +
          ' team)'
      }));
    const team_select_options = this.state.team_list
      .sort((a, b) => a.nickname.localeCompare(b.nickname))
      .map(item => ({
        value: item.id,
        label: item.nickname
      }));

    let account_status_staff_nickname = '';
    for (const key in this.state.staff_list) {
      const staff = this.state.staff_list[key];
      // console.log(staff);
      // console.log(this.state);
      if (staff.id === this.state.account_status_staff) {
        account_status_staff_nickname = staff.nickname;
      }
    }

    return (
      <React.Fragment>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            {/* <FormControl*/}
            {/*  fullWidth*/}
            {/*  error={!this.state.account_type > 0}*/}
            {/*  className={classes.selectFormControl}*/}
            {/*>*/}
            {/*  <InputLabel*/}
            {/*    htmlFor="simple-select"*/}
            {/*    className={classes.selectLabel}*/}
            {/*  >*/}
            {/*    Account Type*/}
            {/*  </InputLabel>*/}
            {/*  <Select*/}
            {/*    MenuProps={{*/}
            {/*      className: classes.selectMenu*/}
            {/*    }}*/}
            {/*    classes={{*/}
            {/*      select: classes.select*/}
            {/*    }}*/}
            {/*    value={this.state.account_type}*/}
            {/*    onChange={this.handleSelectChange}*/}
            {/*    inputProps={{*/}
            {/*      disabled: !this.state.edit_mode,*/}
            {/*      name: "account_type",*/}
            {/*      id: "account-type"*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    <MenuItem*/}
            {/*      key="0x0"*/}
            {/*      disabled*/}
            {/*      classes={{*/}
            {/*        root: classes.selectMenuItem*/}
            {/*      }}*/}
            {/*    >*/}
            {/*      Select account type*/}
            {/*    </MenuItem>*/}
            {/*    {this.state.client_types_list.map((item) => {*/}
            {/*      return (*/}
            {/*        <MenuItem*/}
            {/*          key={item.id}*/}
            {/*          classes={{*/}
            {/*            root: classes.selectMenuItem,*/}
            {/*            selected: classes.selectMenuItemSelected*/}
            {/*          }}*/}
            {/*          value={item.id}*/}
            {/*        >*/}
            {/*          {item.nickname}*/}
            {/*        </MenuItem>*/}
            {/*      );*/}
            {/*    })}*/}
            {/*  </Select>*/}
            {/*</FormControl>*/}

            <GridContainer>
              <GridItem xs={12} md={6}>
                <CustomReactSelect
                  label='Account Type'
                  options={account_type_select_options}
                  value={this.state.account_type}
                  onChange={this.handleCustomReactSelectChange('account_type')}
                  isClearable={false}
                  isDisabled={!this.state.edit_mode}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText='Client Reference'
                  id='external_reference'
                  formControlProps={{fullWidth: true}}
                  inputProps={{
                    disabled: !this.state.edit_mode,
                    value: this.state.external_reference || '',
                    onChange: event => {
                      this.handleChange(event);
                    }
                  }}
                />
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} md={6}>
                <CustomReactSelect
                  label='Responsible Staff Member'
                  options={responsible_staff_member_select_options}
                  value={this.state.responsible_staff_member}
                  onChange={this.handleCustomReactSelectChange('responsible_staff_member')}
                  isClearable={true}
                  isDisabled={!this.state.edit_mode}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomReactSelect
                  label='Team'
                  options={team_select_options}
                  value={this.state.team_id}
                  onChange={this.handleCustomReactSelectChange('team_id')}
                  isClearable={false}
                  isDisabled={!this.state.edit_mode}
                />
              </GridItem>
            </GridContainer>

            <hr />
            <CustomReactSelect
              label='Client Status'
              options={account_status_select_options}
              value={this.state.account_status}
              onChange={this.handleCustomReactSelectChange('account_status')}
              isClearable={false}
              isDisabled={!this.state.edit_mode}
            />
            {this.props.app_state.current_staff_super_admin && (
              <React.Fragment>
                <CustomInput
                  labelText='account status note'
                  id='account_status_notes'
                  formControlProps={{fullWidth: true}}
                  inputProps={{
                    disabled: !this.state.edit_mode,
                    value: this.state.account_status_notes || '',
                    onChange: event => {
                      this.handleChange(event);
                    }
                  }}
                  helpText={'These notes will be visible to the client'}
                />
              </React.Fragment>
            )}

            <ul>
              <li>Last change to status: {this.state.account_status_datetime}</li>
              <li>Last change made by: {account_status_staff_nickname}</li>
            </ul>
          </GridItem>
        </GridContainer>
      </React.Fragment>
    );
  }

  getFullDate = s => {
    return moment(s).format('Do MMMM YYYY');
  };

  validatePassword(event, value, stateName) {
    // var passwordRex = /^(?=.*[a-z].*[a-z])(?=.*[A-Z].*[A-Z])(?=.*\d.*\d)(?=.*\W.*\W)[a-zA-Z0-9\S]{9,}$/;
    // This pattern requires at least two lowercase letters, two uppercase letters, two digits, and two special characters. There must be a minimum of 9 characters total, and no white space characters are allowed.
    // very strong password

    // var passwordRex = /^(?=.*[!@#$%^&*()\-_=+`~\[\]{}?|])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,20}$/;
    // This pattern requires at least longer than 8 characters and contain at least 1 uppercase & 1 number and 1 special character

    const passwordRex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*\S)[A-Za-z\d\S]{6,}$/;
    // This pattern requires at least 6 characters and contain at least 1 number

    this.setState({[stateName]: event.target.value});
    if (passwordRex.test(event.target.value)) {
      this.setState({
        password_state: 'success',
        password_helptext: ''
      });
      return true;
    }

    if (this.state.password !== this.state.password_confirm) {
      this.setState({
        password_helptext: 'Password and Confirm Password must match',
        password_state: 'error'
      });
    } else {
      this.setState({
        password_state: 'error',
        password_helptext: 'Must be at least 6 characters and contain at least 1 number'
      });
    }
    return false;
  }

  render() {
    const {classes} = this.props;

    // For CustomReactSelect. Generate select options for dropdown list.
    const title_select_options = [{label: 'Mr'}, {label: 'Ms'}, {label: 'Mrs'}].map(item => ({
      value: item.label,
      label: item.label
    }));

    const referral_source_select_options = this.state.referral_source_list
      .sort((a, b) => a.nickname.localeCompare(b.nickname))
      .map(item => ({
        value: item.id,
        label: item.nickname
      }));

    const client_status_select_options = this.state.client_status_list.map(item => ({
      value: item.id,
      label: item.nickname
    }));

    if (!this.state.loaded) {
      return null;
    }
    if (!this.state.client_types_list) {
      return null;
    }
    // console.log(this.state.client_status_list[this.state.account_status - 1].nickname)
    const account_status_nickname = this.state.client_status_list[this.state.account_status]
      ? this.state.client_status_list[this.state.account_status - 1].nickname
      : '';

    //definitaion of tab_array

    // console.log(this.state);
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color='rose' icon>
                <div className={classes.flexEnd}>
                  <h4 className={classes.cardIconTitle}>
                    {this.state.edit_mode ? 'Edit Record: ' : 'View Record: '}
                    {this.state.first_name} {this.state.last_name}{' '}
                  </h4>
                  <h4
                    className={classes.cardIconTitle}
                    style={{color: account_status_nickname === 'Approved' ? 'green' : 'red'}}
                  >
                    Client Status: {account_status_nickname}
                  </h4>
                  <div>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.edit_mode}
                          onChange={() => this.toggleEdit()}
                          value='edit_mode'
                          classes={{
                            switchBase: classes.switchBase,
                            checked: classes.switchChecked
                            // icon: classes.switchIcon,
                            // iconChecked: classes.switchIconChecked,
                            // bar: classes.switchBar
                          }}
                        />
                      }
                      classes={{label: classes.label}}
                      label={this.state.edit_mode ? 'Edit Mode' : 'Read Only'}
                    />
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <div style={{padding: 0}}>
                  <form onSubmit={this.onHandleSubmit}>
                    <UserAccountComponent
                      classes={classes}
                      handleSubmit={this.onHandleSubmit}
                      {...this.props}
                      state={this.state}
                      handleChange={this.handleChange}
                      setState={this.setState.bind(this)}
                      handleCustomReactSelectChange={this.handleCustomReactSelectChange}
                      handleToggle={this.handleToggle}
                      client_detail_id={this.props.client_detail_id}
                      change={this.change.bind(this)}
                      handleCreateClientPortalAccount={this.handleCreateClientPortalAccount}
                      toggleForgetModal={this.toggleForgetModal.bind(this)}
                      validatePassword={this.validatePassword.bind(this)}
                      forgetPassword={this.forgetPassword.bind(this)}
                    />
                    <br />
                    <Personal
                      classes={classes}
                      handleSubmit={this.onHandleSubmit}
                      {...this.props}
                      getFullDate={this.getFullDate}
                      state={this.state}
                      handleChange={this.handleChange}
                      setState={this.setState.bind(this)}
                      handleCustomReactSelectChange={this.handleCustomReactSelectChange}
                      handleToggle={this.handleToggle}
                      referral_source_select_options={referral_source_select_options}
                    />
                    <br />
                    <Address
                      classes={classes}
                      handleSubmit={this.handleSubmit}
                      {...this.props}
                      state={this.state}
                      handleChange={this.handleChange}
                      setState={this.setState.bind(this)}
                      handleCustomReactSelectChange={this.handleCustomReactSelectChange}
                      handleToggle={this.handleToggle}
                      referral_source_select_options={referral_source_select_options}
                    />
                    <Button
                      color='primary'
                      /*disabled={!state.edit_mode}*/ type='submit'
                      className={classes.updateProfileButton}
                    >
                      Update
                    </Button>
                  </form>
                </div>
                <Clearfix />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

// BackOfficeClientEdit.propTypes = {
//   classes: PropTypes.object.isRequired
// };

// export default withRouter(withStyles(staffEditStyles)(BackOfficeClientEdit));

const mapStateToProps = state => {
  return {
    app_state: state.app_state,
    clients: state.clients
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadClientDetailsRequest: () => {
      dispatch(loadClientDetailsRequest());
    },
    loadClientDetailsSuccess: () => {
      dispatch(loadClientDetailsSuccess());
    },
    createCognitoAccountForClient: (id, username, password, language_id) => {
      dispatch(createCognitoAccountForClient(id, username, password, language_id));
    },
    updateClient: (data, id) => {
      dispatch(updateClient(data, id));
    }
  };
};

const BackOfficeClientEditContainerComponent = connect(mapStateToProps, mapDispatchToProps)(BackOfficeClientEdit);

export default withRouter(withStyles(staffEditStyles)(BackOfficeClientEditContainerComponent));
